define(["exports", "react", "styled-components", "polished"], function (_exports, _react, _styledComponents, _polished) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.Toast = void 0;
  _react = _interopRequireDefault(_react);
  _styledComponents = _interopRequireDefault(_styledComponents);

  var ContainerToast = _styledComponents.default.div.withConfig({
    displayName: "Toast__ContainerToast",
    componentId: "sc-48dop7-0"
  })(["display:flex;height:100%;width:100%;"]);

  var ToastIcon = _styledComponents.default.div.withConfig({
    displayName: "Toast__ToastIcon",
    componentId: "sc-48dop7-1"
  })(["align-items:center;background:", ";display:flex;height:100%;justify-content:center;min-height:96px;width:100px;box-icon{fill:", ";}"], function (_ref) {
    var theme = _ref.theme,
        type = _ref.type;
    return (0, _polished.rgba)(theme.colors[type], 0.05);
  }, function (_ref2) {
    var theme = _ref2.theme,
        type = _ref2.type;
    return theme.colors[type];
  });

  var icons = {
    success: /*#__PURE__*/_react.default.createElement("box-icon", {
      type: "solid",
      name: "check-circle",
      size: "32px"
    }),
    error: /*#__PURE__*/_react.default.createElement("box-icon", {
      type: "solid",
      name: "x-circle",
      size: "32px"
    }),
    warning: /*#__PURE__*/_react.default.createElement("box-icon", {
      type: "solid",
      name: "error",
      size: "32px"
    })
  };

  var ToastMessage = _styledComponents.default.div.withConfig({
    displayName: "Toast__ToastMessage",
    componentId: "sc-48dop7-2"
  })(["flex:1;padding:24px;> h3,> p{margin:0;padding:0;color:", ";}> p{font-size:1.4em;}"], function (_ref3) {
    var theme = _ref3.theme;
    return theme.colors.dark;
  });

  var Toast = function Toast(_ref4) {
    var message = _ref4.message,
        type = _ref4.type;
    return /*#__PURE__*/_react.default.createElement(ContainerToast, null, /*#__PURE__*/_react.default.createElement(ToastIcon, {
      type: type
    }, icons[type]), /*#__PURE__*/_react.default.createElement(ToastMessage, null, message));
  };

  _exports.Toast = Toast;
  Toast.defaultProps = {
    message: '',
    type: 'success'
  };
});